<template>


   <b-row :key="componentKey">


   <b-col cols="12" sm="12" md="12" lg="4" xl="4"  >


   </b-col>

   <b-col cols="12" sm="12" md="12" lg="4" xl="4"  style="padding:0px;">

    <b-row>

      <perfil :display-name="displayName" :alias="alias" :promo-code="promoCode" :isSidebar="false"  :photo-user="photo" :user-id="userId" :token-auth="tokenAuth" :is-profile-verificated="isProfileVerificated" />
   

<b-col sm="12" md="12" lg="12" xl="12"> 

<p class="title_p">
<feather-icon
                icon="ListIcon"
                size="25"
                class="color_icon"
                />
Más opciones
</p>

</b-col>


<b-col cols="6" sm="6" md="6" lg="6" xl="6">

<b-link   style="width: 100%;" :to="{ name: 'wallets'}"  >
<b-card class="hover_div">
 <b-row>

<b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

  <svg width="25" class="color_icon" height="25" viewBox="0 0 1034 1034" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path fill="currentcolor" d="M497 177q-95 1-179.5 41.5T173 330q-62 75-85 169-28 112 4 222 31 107 111 185 82 80 194 108t222-4q107-32 185-111 80-82 108-194t-4-223q-32-106-111-184-82-81-194-108-53-14-106-13zM483 325l46 12-19 75 38 8 18-74 47 11-19 77q49 17 72 40 27 28 21 67-8 57-59 69 33 17 44 43 13 29-1 70-18 50-62 64-37 11-103-1l-19 77-47-12 19-76-37-9-19 76-47-11 20-78-94-24 23-53 17 5q17 4 17 3 15 4 21-11l31-122 5 1-5-1 21-88q2-21-21-27l-34-8v0l12-50 65 16h-1l30 8zm15 142-23 93 7 2q41 11 64 10 41 0 49-32t-27-51q-19-11-61-20zM463 607l-26 102 9 3q50 13 77 13 49 0 58-35t-34-57q-23-12-73-24z" /></svg>
  
  <p  class="txt_display2">
                   Criptomonedas
                </p>


 </b-col>

  

  </b-row>
  </b-card>

   </b-link>
</b-col>


<b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

<b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#tarjetas'}"  >
<b-card class="hover_div">
<b-row>

<b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

  <feather-icon
                icon="CreditCardIcon"
                size="25"
                class="color_icon"
                />



</b-col>

<b-col  cols="12" sm="12" md="12" lg="12" xl="12">


<p  style="text-align: center !important;font-size: 12px;" class="txt_display2">
            Mis tarjetas de pagos
            </p>


</b-col>

  

  </b-row>
  </b-card>

  </b-link>
</b-col>


<b-col cols="6" sm="6" md="6" lg="6" xl="6">

<b-link   style="width: 100%;" :to="{ name: 'negocio'}"  >
<b-card class="hover_div">
 <b-row>

<b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

  <feather-icon
                icon="ShoppingCartIcon"
                size="25"
                class="color_icon"
                />
  <p  class="txt_display2">
                  Negocios
                </p>


 </b-col>

  

  </b-row>
  </b-card>

   </b-link>
</b-col>


<b-col cols="6" sm="6" md="6" lg="6" xl="6">

<b-link   style="width: 100%;" :to="{ name: 'notificaciones'}"  >
<b-card class="hover_div">
 <b-row>

<b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

  <feather-icon
                icon="BellIcon"
                size="25"
                class="color_icon"
                />
  <p  class="txt_display2">
                  Notificaciones
                </p>


 </b-col>

  

  </b-row>
  </b-card>

   </b-link>
</b-col>

<b-col cols="6" sm="6" md="6" lg="6" xl="6">

<b-link   style="width: 100%;" :to="{ name: 'recargar'}"  >
<b-card class="hover_div">
 <b-row>

<b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">
   <svg width="25" class="icons_colors" height="25"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 612.006 612.006" style="enable-background:new 0 0 612.006 612.006"><g><g><path d="M482.288 437.042c-45.521.0-82.42 36.899-82.42 82.426.0 45.514 36.906 82.414 82.42 82.414 45.521.0 82.414-36.899 82.414-82.414C564.702 473.947 527.809 437.042 482.288 437.042zM482.288 583.58c-35.412.0-64.112-28.7-64.112-64.112.0-35.412 28.7-64.118 64.112-64.118 35.406.0 64.118 28.707 64.118 64.118C546.407 554.88 517.694 583.58 482.288 583.58z"/><path d="M0 262.212h126.044V10.124H0V262.212zM62.385 36.234c18.547.0 33.578 15.05 33.578 33.584.0 18.541-15.031 33.578-33.578 33.578-18.541.0-33.578-15.037-33.578-33.578C28.807 51.284 43.838 36.234 62.385 36.234z"/><path d="M465.55 355.825c0 0-3.372 19.934 10.859 24.352.0.0 15.157 2.836 19.039-10.821l5.691-83.454c.592-8.363-3.933-14.942-3.933-14.942-1.683-2.445-3.655-4.878-5.729-7.266-7.72-3.775-17.192-8.124-28.089-12.567 1.33 1.733 2.653 3.561 3.901 5.451.0.0 5.489 9.346 4.487 18.447L465.55 355.825z"/><path d="M524.437 397.155c0 0 5.199.945 11.092-.851 1.947-23.406 6.075-69.406 9.983-90.411.0.0 3.183-17.602-16.297-28.618.0.0-9.806-5.943-26.81-14.01 2.597 2.83 5.048 5.779 7.096 8.729.0.0 4.752 6.794 4.134 15.428l-6.101 87.834C507.535 375.261 507.39 394.47 524.437 397.155z"/><path d="M573.141 202.493C440.177 81.333 329.933 49.627 329.933 49.627c-24.982-7.273-59.014-7.985-59.014-7.985H157.555V180.29h50.689c53.499 119.742 135.062 183.224 135.062 183.224 23.999 18.881 54.684 45.256 54.684 45.256 21.642 19.675 29.501 17.98 29.501 17.98 17.318.0 16.789-21.698 16.789-21.698.0-39.332-62.94-104.478-62.94-104.478-11.804-13.644-.265-29.948-.265-29.948 19.94-24.913 41.311-34.517 41.311-34.517 8.458-4.714 27.144-.794 27.144-.794 55.863 10.626 97.041 38.683 97.041 38.683 12.85 8.13 11.602 25.688 11.602 25.688-3.542 21.245-8.521 76.799-8.521 76.799-2.54 32.267 15.535 34.278 15.535 34.278 45.439 5.275 46.819-129.428 46.819-129.428C612 231.754 573.141 202.493 573.141 202.493z"/><path d="M508.014 519.827c-2.672-1.739-5.697-3.057-9.081-3.964-3.384-.907-6.813-1.639-10.279-2.193v-18.32c7.317.328 15.22 1.872 23.703 4.62v-16.342c-3.479-1.21-7.279-2.162-11.439-2.855-4.153-.681-8.243-1.147-12.258-1.361v-8.256h-13.127v8.508c-4.449.492-8.464 1.374-12.006 2.647-3.548 1.26-6.561 2.924-9.037 4.985-2.477 2.073-4.38 4.512-5.697 7.355-1.323 2.836-1.985 6.069-1.985 9.699.0 4.456.851 8.092 2.565 10.903 1.702 2.798 3.926 5.061 6.649 6.768 2.723 1.708 5.792 2.987 9.201 3.838 3.416.851 6.85 1.525 10.317 2.01v18.094c-2.798-.063-5.388-.214-7.752-.46-2.37-.246-4.626-.58-6.775-.989-2.136-.416-4.235-.908-6.277-1.494-2.023-.574-4.115-1.242-6.271-2.017v16.184c3.145 1.431 7.09 2.534 11.854 3.334 4.764.807 9.838 1.286 15.226 1.45v8.086h13.127v-8.502c9.081-.989 16.083-3.491 21.012-7.506 4.922-4.015 7.386-9.554 7.386-16.6.0-4.405-.838-8.004-2.515-10.815C512.86 523.829 510.68 521.56 508.014 519.827zM475.526 511.609c-3.573-.655-6.239-1.601-8.01-2.811-1.752-1.21-2.634-2.975-2.634-5.281.0-2.029.769-3.725 2.307-5.073 1.544-1.355 4.33-2.244 8.331-2.685v15.85H475.526zM488.653 545.376v-15.522c3.466.611 6.05 1.506 7.72 2.685 1.683 1.185 2.515 2.93 2.515 5.237C498.888 541.961 495.479 544.488 488.653 545.376z"/></g></g><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/></svg>


  <p  class="txt_display2">
                  Recargas de billetera
                </p>


 </b-col>

  

  </b-row>
  </b-card>

   </b-link>
</b-col>


<b-col cols="6" sm="6" md="6" lg="6" xl="6">

<b-link   style="width: 100%;" :to="{ name: 'referidos'}"  >
<b-card class="hover_div">
 <b-row>

<b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">
   <svg width="25" class="icons_colors" height="25" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 455 455"><g><circle cx="69.803" cy="299.013" r="34.902"/><path d="M69.803 363.914C31.252 363.914.0 395.167.0 433.718h139.606c0-38.551-31.252-69.804-69.803-69.804z"/><circle cx="385.197" cy="299.013" r="34.902"/><path d="M385.197 363.914c-38.551.0-69.803 31.252-69.803 69.803H455c0-38.55-31.252-69.803-69.803-69.803z"/><circle cx="227.5" cy="56.184" r="34.901"/><path d="M227.5 121.085c-38.551.0-69.803 31.252-69.803 69.803h139.606c0-38.551-31.252-69.803-69.803-69.803z"/><polygon points="242.5,240.773 212.5,240.773 212.5,308.896 153.504,342.958 168.504,368.939 227.5,334.877 286.496,368.939 301.496,342.958 242.5,308.896"/></g><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/><g/></svg>


  <p  class="txt_display2">
                  Referidos
                </p>


 </b-col>

  

  </b-row>
  </b-card>

   </b-link>
</b-col>


<b-col cols="6" sm="6" md="6" lg="6" xl="6">

<b-link   style="width: 100%;" :to="{ name: 'retiros'}"  >
<b-card class="hover_div">
 <b-row>

<b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">
  <svg width="25" class="icons_colors" height="25" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path  d="M8 0l2 3H9v2H7V3H6l2-3z"/><path  d="M15 7v8H1V7h14zm1-1H0v10h16V6z"/><path  d="M8 8c1.657.0 3 1.343 3 3s-1.343 3-3 3h5v-1h1V9h-1V8H8z"/><path  d="M5 11c0-1.657 1.343-3 3-3H3v1H2v4h1v1h5c-1.657.0-3-1.343-3-3z"/></svg>
  
  <p  class="txt_display2">
                  Retiros de dinero
                </p>


 </b-col>

  

  </b-row>
  </b-card>

   </b-link>
</b-col>

<b-col cols="6" sm="6" md="6" lg="6" xl="6">

<b-link   style="width: 100%;" :to="{ name: 'transferencias'}"  >
<b-card class="hover_div">
 <b-row>

<b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

  <svg width="25" class="icons_colors" height="25" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32"><path d="M29.9 16.5C29.7 16.2 29.4 16 29 16c-2.2.0-4.3 1-5.6 2.8L22.5 20c-1.1 1.3-2.8 2-4.5 2h-3c-.6.0-1-.4-1-1s.4-1 1-1h1.9c1.6.0 3.1-1.3 3.1-2.9.0.0.0-.1.0-.1.0-.5-.5-1-1-1h-6.1c-3.6.0-6.5 1.6-8.1 4.2l-2.7 4.2c-.2.3-.2.7.0 1l3 5c.1.2.4.4.6.5.1.0.1.0.2.0.2.0.4-.1.6-.2 3.8-2.5 8.2-3.8 12.7-3.8 3.3.0 6.3-1.8 7.9-4.7l2.7-4.8C30 17.2 30 16.8 29.9 16.5z"/><path d="M11 11v3.2c.6-.1 1.3-.2 1.9-.2H19c1.3.0 2.4.8 2.8 2H22c.6.0 1-.4 1-1v-4c.6.0 1-.4 1-1V6c0-.6-.4-1-1-1h-1.2C21.9 4.7 22 4.4 22 4c0-1.7-1.3-3-3-3-.8.0-1.5.3-2 .8C16.5 1.3 15.8 1 15 1c-1.7.0-3 1.3-3 3 0 .4.1.7.2 1H11c-.6.0-1 .4-1 1v4C10 10.6 10.4 11 11 11zm7-7c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1h-1V4zM15 3c.6.0 1 .4 1 1v1h-1c-.6.0-1-.4-1-1S14.4 3 15 3z"/></svg>
  <p  class="txt_display2">
                  Transferencias
                </p>


 </b-col>

  

  </b-row>
  </b-card>

   </b-link>
</b-col>

<b-col cols="6" sm="6" md="6" lg="6" xl="6">

<b-link   style="width: 100%;" :to="{ name: 'transacciones'}"  >
<b-card class="hover_div">
 <b-row>

<b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

  <feather-icon
                icon="ListIcon"
                size="25"
                class="color_icon"
                />
  <p  class="txt_display2">
                  Transacciones
                </p>


 </b-col>

  

  </b-row>
  </b-card>

   </b-link>
</b-col>

<b-col
              sm="12"
              md="12"
              lg="12"
              xl="12"
            >

  


              <app-collapse
                accordion
                type="margin"
              >

                <app-collapse-item title="Configuraciones generales" class="item_profile"  icon="UserIcon">

                  <b-row>
                    <b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

                      <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#general'}"  >
                      <b-card class="hover_div">
                      <b-row>

                      <b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

                        <feather-icon
                                      icon="EditIcon"
                                      size="25"
                                      class="color_icon"
                                      />
                 


                      </b-col>

                      <b-col  cols="12" sm="12" md="12" lg="12" xl="12">

          
                    <p  style="text-align: center !important;font-size: 12px;margin-top: 10px;" class="txt_display2">
                                    Edición de datos personales
                                  </p>


                    </b-col>

                        

                        </b-row>
                        </b-card>

                        </b-link>
                      </b-col>

                     


                      <b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

                              <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#notificaciones'}"  >
                              <b-card class="hover_div">
                              <b-row>

                              <b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

                                <feather-icon
                                              icon="BellIcon"
                                              size="25"
                                              class="color_icon"
                                              />



                              </b-col>

                              <b-col  cols="12" sm="12" md="12" lg="12" xl="12">


                              <p  style="text-align: center !important;font-size: 12px;margin-top: 10px;" class="txt_display2">
                                          Configuración de notificaciones
                                          </p>


                              </b-col>

                                

                                </b-row>
                                </b-card>

                                </b-link>
                              </b-col>


                              <b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

                                <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#bot'}"  >
                                <b-card class="hover_div">
                                <b-row>

                                <b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

                                  <feather-icon
                                                icon="CpuIcon"
                                                size="25"
                                                class="color_icon"
                                                />



                                </b-col>

                                <b-col  cols="12" sm="12" md="12" lg="12" xl="12">


                                <p  style="text-align: center !important;font-size: 12px;margin-top: 10px;" class="txt_display2">
                                            Configuración del Bot de EQCoop
                                            </p>


                                </b-col>

                                  

                                  </b-row>
                                  </b-card>

                                  </b-link>
                                </b-col>

                                <b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

                                    <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#banco'}"  >
                                    <b-card class="hover_div">
                                    <b-row>

                                    <b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

                                      <feather-icon
                                                    icon="LayersIcon"
                                                    size="25"
                                                    class="color_icon"
                                                    />



                                    </b-col>

                                    <b-col  cols="12" sm="12" md="12" lg="12" xl="12">


                                    <p  style="text-align: center !important;font-size: 12px;margin-top: 10px;" class="txt_display2">
                                                Gestión de cuenta bancaria
                                                </p>


                                    </b-col>

                                      

                                      </b-row>
                                      </b-card>

                                      </b-link>
                                    </b-col>

                                 

                                    <b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

                                        <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#biografia'}"  >
                                        <b-card class="hover_div">
                                        <b-row>

                                        <b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

                                          <feather-icon
                                                        icon="InstagramIcon"
                                                        size="25"
                                                        class="color_icon"
                                                        />



                                        </b-col>

                                        <b-col  cols="12" sm="12" md="12" lg="12" xl="12">


                                        <p  style="text-align: center !important;font-size: 12px;" class="txt_display2">
                                                    Mi biografía y redes sociales
                                                    </p>


                                        </b-col>

                                          

                                          </b-row>
                                          </b-card>

                                          </b-link>
                                        </b-col>

                                        <b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

                                        <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#alias'}"  >
                                        <b-card class="hover_div">
                                        <b-row>

                                        <b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

                                          <feather-icon
                                                        icon="AtSignIcon"
                                                        size="25"
                                                        class="color_icon"
                                                        />



                                        </b-col>

                                        <b-col  cols="12" sm="12" md="12" lg="12" xl="12">


                                        <p  style="text-align: center !important;font-size: 12px;" class="txt_display2">
                                                    Alias del perfil
                                        </p>


                                        </b-col>

                                          

                                          </b-row>
                                          </b-card>

                                          </b-link>
                                        </b-col>

                                      

                  </b-row>
               

                  
                </app-collapse-item>


                <app-collapse-item title="Configuraciones de seguridad" class="item_profile"  icon="LockIcon">

                      <b-row>

                        <b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

                          <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#verificacion'}"  >
                          <b-card class="hover_div">
                          <b-row>

                          <b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

                            <feather-icon
                                          icon="CheckCircleIcon"
                                          size="25"
                                          class="color_icon"
                                          />



                          </b-col>

                          <b-col  cols="12" sm="12" md="12" lg="12" xl="12">


                          <p  style="text-align: center !important;font-size: 12px;" class="txt_display2">
                                      Verificación de cuenta
                                      </p>


                          </b-col>

                            

                            </b-row>
                            </b-card>

                            </b-link>
                          </b-col>

                          <b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

                            <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#password'}"  >
                            <b-card class="hover_div">
                            <b-row>

                            <b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

                              <feather-icon
                                            icon="KeyIcon"
                                            size="25"
                                            class="color_icon"
                                            />



                            </b-col>

                            <b-col  cols="12" sm="12" md="12" lg="12" xl="12">


                            <p  style="text-align: center !important;font-size: 12px;" class="txt_display2">
                                        Actualización de contraseña
                                        </p>


                            </b-col>

                              

                              </b-row>
                              </b-card>

                              </b-link>
                            </b-col>

                          <b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

                            <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#pin'}"  >
                            <b-card class="hover_div">
                            <b-row>

                            <b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

                              <feather-icon
                                            icon="LockIcon"
                                            size="25"
                                            class="color_icon"
                                            />



                            </b-col>

                            <b-col  cols="12" sm="12" md="12" lg="12" xl="12">


                            <p  style="text-align: center !important;font-size: 12px;" class="txt_display2">
                                        Gestión del código PIN
                                        </p>


                            </b-col>

                              

                              </b-row>
                              </b-card>

                              </b-link>
                            </b-col>

                            <b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

                            <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#sesiones'}"  >
                            <b-card class="hover_div">
                            <b-row>

                            <b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

                              <feather-icon
                                            icon="SmartphoneIcon"
                                            size="25"
                                            class="color_icon"
                                            />



                            </b-col>

                            <b-col  cols="12" sm="12" md="12" lg="12" xl="12">


                            <p  style="text-align: center !important;font-size: 12px;" class="txt_display2">
                                        Inicios de sesiones
                                        </p>


                            </b-col>

                              

                              </b-row>
                              </b-card>

                              </b-link>
                            </b-col>

                            <b-col cols="6" sm="6" md="6" lg="6" xl="6" style="margin-bottom: 10px" >

                              <b-link   style="width: 100%;" :to="{ name: 'perfil', hash: '#eliminar'}"  >
                              <b-card class="hover_div">
                              <b-row>

                              <b-col style="text-align: center;" cols="12" sm="12" md="12" lg="12" xl="12">

                                <feather-icon
                                              icon="Trash2Icon"
                                              size="25"
                                              class="color_icon"
                                              />



                              </b-col>

                              <b-col  cols="12" sm="12" md="12" lg="12" xl="12">


                              <p  style="text-align: center !important;font-size: 12px;" class="txt_display2">
                                          Eliminación de cuenta
                                          </p>


                              </b-col>

                                

                                </b-row>
                                </b-card>

                                </b-link>
                              </b-col>


                        </b-row>

                        </app-collapse-item>

               

              </app-collapse>
      
            </b-col>


<b-col sm="12" md="12" lg="12" xl="12">
  <hr>

  </b-col>


   

       <b-col  @click="logout" sm="12" md="12" lg="12" xl="12">

        <div class="menu_opcion">

          <feather-icon
                  icon="LogOutIcon"
                  size="18"
                  style="margin-right: 5px;"
                  /> Cerrar sesión

          </div>
            
      
        </b-col>

    </b-row>


   </b-col>


   <b-col cols="12" sm="12" md="12" lg="4" xl="4"  >


   </b-col>

     
 </b-row>



</template>

<script>
import {
  BLink,BAvatar, BRow, BCol, BCard,BFormCheckbox
} from 'bootstrap-vue'
import AppCollapse from '@core/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/app-collapse/AppCollapseItem.vue'
import Perfil from './Perfil.vue'

export default {
  components: {
    BAvatar,
    AppCollapse,
    AppCollapseItem,
    BLink,
    BRow,
    BCol,
    BFormCheckbox,
    BCard,
    Perfil,
  },
    directives: {

  },
  data() {

    const datos_json = JSON.parse(this.$userGlobal);


        return {
            componentKey: 0,
            promoCode:datos_json.promoCode,
              displayName:datos_json.displayName,
          photo:datos_json.photoUser,
          userId:datos_json.userId,
          alias:datos_json.alias,
          tokenAuth:this.$tokenGlobal,
          isProfileVerificated: datos_json.isProfileVerificated,

        }




  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {


},
activated() {

  this.$eventBus.$emit('sextoMenu1')
       this.$eventBus.$emit('sextoMenu2')
},

  mounted() {



     
    document.title = 'EQCoop - Otras opciones'

       this.$eventBus.$on('reiniciarOtros', () => {
      this.componentKey += 1
    })


   
  },
  methods: {

    

    logout() {

      this.exit(this.userId,this.tokenAuth, true);


    },


  },
}
</script>

<style lang="scss">






</style>
